module.exports = __webpack_public_path__ + "img/atten.64b03441.png";